import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import { DonutChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { objectToSeries, orderBy } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";
import ChartWithControls from "@/components/common/chart-with-controls";
import { getCasesByField } from "@/services/api-reexam";

const FlexibleDonutChart = makeWidthFlexible(DonutChart);

// Hoisted so SWR's cache key (which includes apiCall identity) is stable across renders.
const fetchByRequestGranted = q => getCasesByField(q, "is_request_granted", { "0": "No", "1": "Yes" });
const fetchByClaimCancelled = q => getCasesByField({ exparte_status: "Terminated", ...q }, "is_claim_cancelled", { "0": "No", "1": "Yes" });

const ByStatus = props => (
  <Row>
    <Col span={24} xl={12}>
      <ChartWithControls
        apiCall={fetchByRequestGranted}
        query={props.filter}
        chart={FlexibleDonutChart}
        dataFormatter={data => orderBy(objectToSeries(data), ["Yes", "No"])}
        title="Cases With Granted Request"
        colorMap={{ Yes: Colors.blue500, No: Colors.grey400 }}
        height={400}
        scrollable={false}
      />
    </Col>
    <Col span={24} xl={12}>
      <ChartWithControls
        apiCall={fetchByClaimCancelled}
        query={props.filter}
        chart={FlexibleDonutChart}
        dataFormatter={data => orderBy(objectToSeries(data), ["Yes", "No"])}
        title="Terminated Cases With At Least One Claim Cancelled"
        colorMap={{ Yes: Colors.blue500, No: Colors.grey400 }}
        height={400}
        scrollable={false}
      />
    </Col>
  </Row>
);

ByStatus.propTypes = {
  filter: PropTypes.object
};

export default ByStatus;
